import { render, staticRenderFns } from "./ProductTeaser.vue?vue&type=template&id=58ee6606&scoped=true&"
import script from "./ProductTeaser.vue?vue&type=script&lang=js&"
export * from "./ProductTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ProductTeaser.vue?vue&type=style&index=0&id=58ee6606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee6606",
  null
  
)

export default component.exports